import { gql } from '@apollo/client';
import { getClient } from '../client-graphql';
import { BlockPageIntroFragmentFragment } from '@fm-nx/contentful-types';
import { ButtonFragment } from './fragments/fragment-button';
import { ImageWrapperFragment } from './fragments/fragment-image-wrapper';

export const BlockPageIntroFragment = gql(`
    fragment BlockPageIntroFragment on BlockPageIntro {
        __typename
        sys {
            id
        }
        overline
        headerText
        headerParagraph
        image {
            ...ImageWrapperFragment
        }
        button {
            ...ButtonFragment
        }
        tableOfContents
    }
`);

export async function getBlockPageIntroById(id: string, preview = false) {
    type BlockPageIntroQueryResponse = {
        blockPageIntroCollection?: {
            items: BlockPageIntroFragmentFragment[];
        };
    };
    const { data } = await getClient(preview).query<BlockPageIntroQueryResponse>({
        query: gql`
            query GetBlockPageIntroById($id: String!, $preview: Boolean) {
                blockPageIntroCollection(where: { sys: { id: $id } }, preview: $preview) {
                    items {
                        ...BlockPageIntroFragment
                    }
                }
            }
            ${ButtonFragment}
            ${BlockPageIntroFragment}
            ${ImageWrapperFragment}
        `,
        variables: {
            id,
            preview,
        },
    });
    return data?.blockPageIntroCollection?.items[0];
}
